import { useMemo } from 'react';
import { openPanel } from '../openpanel';

type TrackProperties = Record<string, unknown>;
type IdentifyPayload = {
  profileId: string;
  email?: string;
  firstName?: string;
  properties?: Record<string, unknown>;
};
type IncrementPayload = {
  profileId: string;
  property: string;
  value?: number;
};
type DecrementPayload = {
  profileId: string;
  property: string;
  value?: number;
};

export interface UseOpenPanelApi {
  track: (name: string, properties?: TrackProperties) => void;
  identify: (payload: IdentifyPayload) => void;
  screenView: (
    pathOrProperties?: string | TrackProperties,
    properties?: TrackProperties
  ) => void;
  setGlobalProperties: (properties: Record<string, unknown>) => void;
  increment: (payload: IncrementPayload) => void;
  decrement: (payload: DecrementPayload) => void;
  clear: () => void;
  isReady: boolean;
  ready: () => void;
}

export function useOpenPanel(): UseOpenPanelApi {
  return useMemo<UseOpenPanelApi>(
    () => ({
      track: (name, properties) => openPanel.track(name, properties),
      identify: (payload) => openPanel.identify(payload),
      screenView: (pathOrProperties, properties) =>
        openPanel.screenView(pathOrProperties, properties),
      setGlobalProperties: (properties) =>
        openPanel.setGlobalProperties(properties),
      increment: (payload) => openPanel.increment(payload),
      decrement: (payload) => openPanel.decrement(payload),
      clear: () => openPanel.clear(),
      isReady: openPanel.isReady(),
      ready: () => openPanel.ready(),
    }),
    []
  );
}
